module.exports = __webpack_public_path__ + "startpage-746fed5a/A3-c284a2bb285cd0f50bbcb2f770da1b6e.svg";